import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultShowtimeSummaryAssets = {
    siteIconName: 'location-pin',
    startsAtIconName: 'calendar-clock',
    screenIconName: 'screen-wth-seats',
    runtimeIconName: 'clock-duration',
    seatIconName: 'seat'
};
export const showtimeSummaryAssetsValidator = Validator.object({
    siteIconName: nonEmptyStringValidator,
    startsAtIconName: nonEmptyStringValidator,
    screenIconName: nonEmptyStringValidator,
    runtimeIconName: nonEmptyStringValidator,
    seatIconName: nonEmptyStringValidator
});
